import Vue from 'vue';
import VueResource from 'vue-resource'

Vue.use(VueResource);
Vue.http.options.root = process.env.VUE_APP_API;

Vue.http.interceptors.push((request, next) => {
    request.headers.set('Authorization', `Bearer ${localStorage.getItem('session_id')}`)
    next()
})

export default Vue.http;